import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postReindexCustomer } from '../../../../api';

export const adminSearchShardCatalogDetailsGetSlice = createPostAsyncSlice({
	name: 'AdminSearchShardCatalogReindexCustomer',
	receive: true,
	request: true,
	requestHandler: postReindexCustomer,
	retainDataOnRequest: false
});
